import {Component, OnInit} from '@angular/core';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {CompanyStatus} from "../type/company-status";
import {Company} from "../type/company";

@Component({
    selector: 'app-company-status',
    templateUrl: './company-status.component.html',
})
export class CompanyStatusComponent implements OnInit {
    node = 'company-status';
    companyStatuses: [CompanyStatus] = [CompanyStatus];

    isChecked = false;
    checkedList = [];

    constructor(
        private dataService: DataService,
        private apiService: ApiService
    ) {}

    ngOnInit() {
        this.dataService.refresh();
        this.getAll();
    }

    resetData() {
        this.getAll();
        this.isChecked = false;
        this.checkedList = [];
    }

    getAll(): void {
        this.apiService.getAll(this.node)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.companyStatuses = [{"company_status_id":""}];
                    } else {
                        this.companyStatuses = response.json().data;
                    }
                },
                (error) => {this.companyStatuses = [{"company_status_id":""}];}
            );
    }

    onDelete() {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.node, this.checkedList)
                .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Unable to delete Company Status');
                    } else {
                        alert('Company Status Deleted Successfully');
                    }
                    this.resetData();
                });
        }
    }

    updateCheckList(id) {
        if (this.checkedList.indexOf(id) == -1) {
            this.checkedList.push(id);
        } else {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
        }
    }

    toggleCheckBox() {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.checkedList = this.companyStatuses.map(function(a) {return a.company_status_id;});
        } else {
            this.checkedList = [];
        }
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }
}



// WEBPACK FOOTER //
// ./src/app/company-status/company-status.component.ts